export const charityListSize = 25;
export const PPGF_ENROLLED = 'PPGF_ENROLLED';

export const PRODUCT_TYPE = {
  FUNDRAISER_DIRECT: 'FUNDRAISER_DIRECT',
  FUNDRAISER_PARTNER: 'FUNDRAISER_PARTNER',
};
